// src/subscreens/admin/editRawMaterial/EditRawMaterial.jsx
//
// CHANGED: No longer uses useInventory() context.
// Receives full `material` object and `onUpdate` callback via props.

import React, { useState, useEffect, useContext } from "react";
import Modal from "../../../components/admin/modal/ProductModel";
import "../../../assets/css/admin/editRawMaterial/EditRawMaterial.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const EditRawMaterial = ({ isOpen, onClose, material, onUpdate }) => {
  // const [formData, setFormData] = useState({
  //   name: "",
  //   category: "",
  //   currentStock: "",
  //   minimumStock: "",
  //   reorderPoint: "",
  //   unitPrice: "",
  //   unit: "",
  //   supplier: "",
  // });
  const { baseUrl, authToken } = useContext(AppContext);
  const [errors, setErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [idToUpdate, setIdToUpdate] = useState("");
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [currentStock, setCurrentStock] = useState("");
  const [minimumStock, setMinimumStock] = useState("");
  //const [reorderPoint, setReorderPoint] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [unit, setUnit] = useState("");
  const [supplier, setSupplier] = useState("");

  const editInventory = () => {
    console.log("edit inventory called!");
    const formData = new FormData();
    formData.append("id", idToUpdate);
    formData.append("name", name);
    formData.append("adcategory_id", category);
    formData.append("currentStock", currentStock);
    formData.append("minimumStock", minimumStock);
    formData.append("unitPrice", unitPrice);
    formData.append("unit", unit);
    formData.append("supplier", supplier);
    axios.post(`${baseUrl}/admin/inventory/editInventory`, formData, {
      headers: {
        Authorization: `Bearer${authToken}`
      }
    }).then((response) => {
      console.log(response.data);
      setIsSaving(false);
    }).catch((error) => {
      console.log(error);
      setIsSaving(false);
    })
  }

  // Populate form when material prop arrives
  useEffect(() => {
    if (material) {
      setIdToUpdate(material.id);
      setName(material.name);
      setCategory(material.adcategory_id);
      setCurrentStock(material.currentStock);
      setMinimumStock(material.minimumStock);
      //setReorderPoint(material.reorderPoint);
      setUnitPrice(material.unitPrice);
      setUnit(material.unit);
      setSupplier(material.supplier);

      setErrors({});
    }
  }, [material]);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  //   if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  // };

  const validate = () => {
    const errs = {};
    if (!name.trim()) errs.name = "Material name is required";
    if (!category) errs.category = "Category is required";
    if (!unit.trim()) errs.unit = "Unit is required";
    if (!supplier.trim()) errs.supplier = "Supplier is required";
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    setIsSaving(true);
    editInventory();
    setTimeout(() => {
      // Pass updated data up to parent — parent updates local state
      onUpdate({

        id: idToUpdate,
        name,
        category,
        currentStock: Number(currentStock),
        minimumStock: Number(minimumStock),
       // reorderPoint: Number(reorderPoint),
        unitPrice: Number(unitPrice),
        unit,
        supplier,
      });
      setIsSaving(false);
    }, 1000);
  };

  // Guard: if no material passed, don't render
  if (!material) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit Raw Material"
      size="large"
    >
      <form className="inv-edit-form" onSubmit={handleSubmit}>
        <div className="inv-edit-grid">
          {/* Name */}
          <div className="inv-edit-group inv-edit-full">
            <label htmlFor="name">Material Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={(event) => {
                setName(event.target.value)
              }}
              className={errors.name ? "inv-edit-error" : ""}
            />
            {errors.name && (
              <span className="inv-edit-error-text">{errors.name}</span>
            )}
          </div>

          {/* Category */}
          <div className="inv-edit-group">
            <label htmlFor="category">Category *</label>
            <select
              id="category"
              name="category"
              value={category}
              onChange={(event) => {
                setCategory(event.target.value)
              }}
              className={errors.category ? "inv-edit-error" : ""}
            >
              <option value="">Select category</option>
              <option value="1">Wood</option>
              <option value="2">Fabric</option>
              <option value="3">Upholstery</option>
              <option value="4">Hardware</option>
              <option value="5">Cushioning</option>
              <option value="6">Finishing</option>
              <option value="7">Glass</option>
              <option value="8">Metal</option>
            </select>
            {errors.category && (
              <span className="inv-edit-error-text">{errors.category}</span>
            )}
          </div>

          {/* Unit */}
          <div className="inv-edit-group">
            <label htmlFor="unit">Unit *</label>
            <input
              type="text"
              id="unit"
              name="unit"
              value={unit}
              onChange={(event) => {
                setUnit(event.target.value)
              }}
              className={errors.unit ? "inv-edit-error" : ""}
              placeholder="e.g., pcs, kg, meters"
            />
            {errors.unit && (
              <span className="inv-edit-error-text">{errors.unit}</span>
            )}
          </div>

          {/* Current Stock */}
          <div className="inv-edit-group">
            <label htmlFor="currentStock">Current Stock</label>
            <input
              type="number"
              id="currentStock"
              name="currentStock"
              value={currentStock}
              onChange={(event) => {
                setCurrentStock(event.target.value)
              }}
              min="0"
            />
          </div>

          {/* Minimum Stock */}
          <div className="inv-edit-group">
            <label htmlFor="minimumStock">Minimum Stock</label>
            <input
              type="number"
              id="minimumStock"
              name="minimumStock"
              value={minimumStock}
              onChange={(event) => {
                setMinimumStock(event.target.value)
              }}
              min="0"
            />
          </div>

          {/* Reorder Point */}
          {/* <div className="inv-edit-group">
            <label htmlFor="reorderPoint">Reorder Point</label>
            <input
              type="number"
              id="reorderPoint"
              name="reorderPoint"
              value={reorderPoint}
              onChange={(event) => {
                setReorderPoint(event.target.value)
              }}
              min="0"
            />
          </div> */}

          {/* Unit Price */}
          <div className="inv-edit-group">
            <label htmlFor="unitPrice">Unit Price (PKR)</label>
            <input
              type="number"
              id="unitPrice"
              name="unitPrice"
              value={unitPrice}
              onChange={(event) => {
                setUnitPrice(event.target.value)
              }}
              min="0"
            />
          </div>

          {/* Supplier */}
          <div className="inv-edit-group inv-edit-full">
            <label htmlFor="supplier">Supplier *</label>
            <input
              type="text"
              id="supplier"
              name="supplier"
              value={supplier}
              onChange={(event) => {
                setSupplier(event.target.value)
              }}
              className={errors.supplier ? "inv-edit-error" : ""}
              placeholder="e.g., Punjab Timber Co."
            />
            {errors.supplier && (
              <span className="inv-edit-error-text">{errors.supplier}</span>
            )}
          </div>
        </div>

        <div className="inv-edit-actions">
          <button
            type="button"
            className="inv-edit-cancel"
            onClick={onClose}
            disabled={isSaving}
          >
            Cancel
          </button>
          <button type="submit" className="inv-edit-save" disabled={isSaving}>
            {isSaving ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default EditRawMaterial;
